import { Component, SimpleChanges } from '@angular/core';
import { ComponentModalBase } from '@framework/base';
import { ToastrService } from 'ngx-toastr';

export interface UploadTagsCsvModalData {
  inbound: boolean;
  allowMirror?: boolean;
}

export interface UploadTagsCsvModalResult {
  file: File;
  mirror: boolean;
}

@Component({
  selector: 'app-upload-tags-csv-modal',
  templateUrl: './upload-tags-csv-modal.component.html',
  styleUrls: ['./upload-tags-csv-modal.component.css']
})
export class UploadTagsCsvModalComponent extends ComponentModalBase<UploadTagsCsvModalData> {
  public mirror = false;
  public sampleRows = [
    { tag: 'Leadership', show: 'show' },
    { tag: 'Customer success', show: 'show' },
    { tag: 'Internal only', show: 'hide' }
  ];

  constructor(private toastService: ToastrService) {
    super();
  }

  protected onInit(): void {

  }

  protected onDestroy(): void {

  }

  protected onChanges(changes: SimpleChanges): void {

  }

  protected onDoCheck(): void {

  }

  protected onAfterContentInit(): void {

  }

  protected onAfterContentChecked(): void {

  }

  protected onAfterViewInit(): void {

  }

  protected onAfterViewChecked(): void {

  }

  get showMirror(): boolean {
    return !!(this.initialState && this.initialState.allowMirror);
  }

  get mirrorLabel(): string {
    return this.initialState && this.initialState.inbound
      ? 'Also add these tags to user stories'
      : 'Also add these tags to guest stories';
  }

  public close() {
    this.onClose.emit(null);
  }

  public onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) {
      return;
    }
    const isCsv = /\.csv$/i.test(file.name) || file.type === 'text/csv' || file.type === 'application/vnd.ms-excel';
    if (!isCsv) {
      this.toastService.error('Upload a CSV file.');
      return;
    }
    const result: UploadTagsCsvModalResult = { file, mirror: this.showMirror && this.mirror };
    this.onClose.emit(result);
  }

  public downloadSample() {
    const lines = ['Tag,Show'].concat(this.sampleRows.map((row) => `${row.tag},${row.show}`));
    const blob = new Blob([lines.join('\n') + '\n'], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'tags-sample.csv';
    link.click();
    URL.revokeObjectURL(url);
  }
}
